<template>
  <div data-color="dark" class="js-header-panel ">
    <section
      data-color="clear"
      class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel"
    >
      <div
        class="c-page__header o-wrapper--panel"
        :style="
          'transform:translateX(' +
            headerPageSize[2] +
            'px) translateY(' +
            headerPageSize[3] +
            'px) scale(' +
            headerPageSize[4] +
            ')'
        "
      >
        <img
          src="/static/HeadImages/Setup.jpg"
          class="u-absolute u-pos-tl"
          :style="
            'width:' +
              headerPageSize[0] +
              'px; height:' +
              headerPageSize[1] +
              'px'
          "
        />
        <div class="c-puzzle o-wrapper--panel u-fit u-overflow-h">
          <div
            class="c-puzzle__piece u-absolute"
            style="background-color: rgb(255, 255, 255); opacity: 0.29;"
          ></div>
          <div
            class="c-puzzle__piece u-absolute"
            style="background-color: rgb(255, 255, 255); opacity: 0.29;"
          ></div>
        </div>
      </div>
      <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
        <div
          class="u-relative u-inline-block u-valign-middle u-marg-t-vh1of10 u-fit-w u-pad-l-w3of12 u-pad-l-w2of12@xl u-pad-r-w4of12 u-pad-r-w3of12@xl u-pad-x-w1of12@sm"
        >
          <h1
            class="t-h2-main-title-marine-holdings c-page__subtitle t-text--base-bold  t-text-lh--md u-color--black"
            v-html="content.title"
          ></h1>
          <div class="introduction__inner">
            <div class="introduction__borderLeft scroll">
              <div class="scroll">
                <span class="background"></span>
                <span class="triangle"></span>
                <span class="label">
                  <!--<app-push-button :visible="isButtonVisible" :isIntro="!0" :active="isButtonActive" :to="{ name: '/'}" :text="uiexplore" >{{uiexplore}}</app-push-button>-->Scroll
                  to discover</span
                >
              </div>
            </div>
            <div class="introduction__titles">
              <div class="introduction__titlesInner">
                <div class="introduction__subtitle">
                  <h1 class="t-h4 t-text--roman t-text-lh--md u-color--black">
                    <!-- <app-animated-text :text="contentNavalVessel.smalldescriptioon" :active="!0" ></app-animated-text>-->
                    <app-sliced-text
                      :content="content.subtitle"
                    ></app-sliced-text>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      class="c-page c-blog u-pad-x-w3of12 u-pad-x-w1of12@sm u-pad-t-md u-pad-t-ultra@sm "
    >
      <router-link
        :to="post.LinkurlSlug"
        class="c-blog__article c-team__link__asidewoekshop  u-fit-w t-link u-flex u-flex-fw--wrap u-pad-y-lg u-pad-y-lg@sm"
        v-if="areTherePosts"
        v-for="(post, index) in posts"
        :data-index="index"
        :id="post.title.replace(/\s/g, '')"
      >
        <div
          class="asidewoekshop  c-workshop__link__photo-container-innovation-setup js-photo-container u-relative o-box--1by3  u-overflow-h u-force-3d"
          style="ordder:1"
        >
          <div
            class="c-team__link__photo__overlay--middle u-absolute u-pos-t u-zindex--2"
          ></div>
          <img
            class="c-team__link__photo__Workshop  u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden inspire__image_handler_big"
            :id="post.Stock_No.replace(/\s/g, '')"
            :src="post.images[0].sizes.medium"
            :alt="post.title"
          />
          <img
            class="c-team__link__photo__Workshop  u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden inspire__image_handler_small"
            :id="post.Stock_No.replace(/\s/g, '')"
            :src="post.images[0].sizes.large"
            :alt="post.title"
          />
        </div>
        <div
          class="asidewoekshop c-workshop__link__description-container-setup  u-pad-y-xs@550  u-marg-l0-sm@sm u-pad-t-xs@sm "
          style="ordder:2,padding-top:-3px;"
        >
          <div class="containercarousel_Image">
            <div class="blockdownInfo u-marg-t-xs@sm">
              <div class="style-3">
                <del class="t-text--ultra-amount name u-color--black"></del>
                <ins class="t-text--ultra-amount">
                  <span class="amount  t-text--roman-italic">{{
                    post.date
                  }}</span>
                </ins>
              </div>
            </div>
          </div>
        </div>
        <h4
          class="t-text--ms  u-align-left u-color--gray t-text--base-bold  c-inspire-pcomingp---boxblue-blog__article__description u-marg-y-sm"
          v-html="post.first_paragraph_shorted"
        ></h4>
      </router-link>
      <div
        class="c-blog__article u-flex u-flex-fd--column@sm u-pad-y-xl"
        v-if="!areTherePosts"
      >
        <div class="u-fit-w">
          <h2
            class="t-h5 t-text--roman u-marg-b-md t-text--base-bold t-text-lh--md"
            v-html="posts[0].title"
          ></h2>
        </div>
      </div>
      <!---->
      <!--<footer class="c-blog__footer u-pad-t-md u-pad-b-xxl">
           <div class="c-blog__footer__prev u-w2of10 u-uppercase">
                 <router-link v-if="currentPageIndex > 1 && 0 !== currentPageIndex" class="c-blog__footer__prev__link t-text--roman-italic t-text--roman-italic u-relative u-color--gray" :to="'/theelitecars/current-stock?page='+(currentPageIndex - 1)">
                    Prev
                 </router-link>
            </div>
           <div class="c-blog__footer__pagination u-w6of10">
                     <router-link v-if="currentPageIndex>3" :to="'/theelitecars/current-stock?page=1'+pages[0].index" class="t-text--roman-italic c-blog__footer__pagination__page  u-relative u-color--gray" :class="'c-blog__footer__pagination__page--'+pages[0].index">
                    {{"0"+(pages[0].index)}}
                    </router-link>
                    <div v-if="currentPageIndex>4"  class="c-blog__footer__pagination__page t-text--roman-italic" >
                      ...
                   </div>
                   <router-link v-if="indexp <= currentPageIndex + 1 && indexp >= currentPageIndex || indexp >= currentPageIndex - 3 && indexp <= currentPageIndex"  v-for="(page, indexp)  in pages" :key="page.id" class="c-blog__footer__pagination__page u-relative u-color--gray t-text--roman-italic" :class="[{'is-active':page.index===currentPageIndex},'c-blog__footer__pagination__page--'+indexp]" :to="'/theelitecars/current-stock?page='+ page.index">
                     {{page.index<10?"0"+page.index:page.index}}
                   </router-link>
                   <div  v-if="currentPageIndex<pages.length-3"   class="c-blog__footer__pagination__page t-text--roman-italic">
                     ...
                   </div>

                   <router-link v-if="currentPageIndex < pages.length-2"  class="c-blog__footer__next__link u-relative t-text--roman-italic u-color--gray" :class="['c-blog__footer__pagination__page--'+pages[pages.length-1].index]" :to="'/theelitecars/current-stock?page='+ pages[pages.length-1].index">
                    {{pages[pages.length-1].index<10?"0"+pages[pages.length-1].index:pages[pages.length-1].index}}
                   </router-link>
         </div>
           <div class="c-blog__footer__next u-w2of10 u-uppercase">
           <router-link v-if="currentPageIndex < pages.length && 0 !== currentPageIndex"  class="c-blog__footer__next__link t-text--roman-italic u-relative u-color--gray"  :to="'/theelitecars/current-stock?page='+ (currentPageIndex + 1)">
            Next
           </router-link>
         </div>
       </footer>-->
    </div>
    <app-footer
      :globalContent="globalContent"
      :adminContent="adminContent"
    ></app-footer>
  </div>
</template>
<script>
import { format, compareAsc } from "date-fns";
import AppFooter from "../app-footer/index.vue";
import AppSlicedText from "../app-sliced-text/index.vue";
import CoreAjaxForm from "../core-ajax-form/index.vue";

import AppScrollObject from "../app-scroll-object/index.vue";

export default {
  components: {
    "app-sliced-text": AppSlicedText,
    "app-footer": AppFooter,
    "core-ajax-form": CoreAjaxForm,
    "app-scroll-object": AppScrollObject,
  },
  props: {
    adminContent: {
      type: Object,
      default: function() {},
    },
    globalContent: {
      type: Object,
      default: function() {},
    },
    headerPageSize: {
      type: Array,
      default: function() {},
    },
  },
  data: function() {
    return {
      areTherePosts: !1,
      selectedOption: "",
      CarModel: Object(),
      popinContent: null,
      popinTitle: null,
      isPopinActive: !1,
      isPopinActivePhotos: !1,
      isButtonClicked: false,
    };
  },
  computed: {
    content: function() {
      return this.adminContent.en.pages.repairandrefit;
    },
    getsearchContent: function() {
      return this.adminContent.en.pages.SearchContent;
    },
    computedPosts: function() {
      var t = [];
      if (this.$route.query.page) {
        if (Object.keys(this.adminContent.en.posts_setup).length > 0) {
          if (this.adminContent.en.posts_setup[this.$route.query.page]) {
            this.areTherePosts = !0;
            for (
              var e = 0,
                n = this.adminContent.en.posts_setup[this.$route.query.page]
                  .length;
              e < n;
              e += 1
            ) {
              var r = this.adminContent.en.posts_setup[this.$route.query.page][
                e
              ];
              /*r.dateFormated = {
                                              day: format(r.post_wp.post_date, "DD"),
                                              month: format(r.post_wp.post_date, "MMMM"),
                                              year: format(r.post_wp.post_date, "YY")
                                          },*/
              t.push(r);
            }
            this.popinContent = t[0];
          } else {
            (this.areTherePosts = !1),
              t.push({
                title: "Error - Page not found",
                first_paragraph_shorted:
                  "Incorrect page number. <br /> Please click on one of the page numbers below.",
                dateFormated: {
                  day: 404,
                  month: "",
                  year: "",
                },
              });
          }
        }
      } else {
        (this.areTherePosts = !1),
          t.push({
            title: "No recents announcements yet.",
            first_paragraph_shorted: "",
            dateFormated: {
              day: "",
              month: "",
              year: "",
            },
          });
      }
      return t;
    },
    computedPages: function() {
      var t = [];
      if (this.$route.query.page) {
        t.length = 0;
        for (
          var e = 0, n = Object.keys(this.adminContent.en.posts_setup).length;
          e < n;
          e += 1
        ) {
          var r = Object.keys(this.adminContent.en.posts_setup)[e];
          t.push({
            index: parseInt(r, 10),
            isVisible: !0,
          });
        }
      }
      return t;
    },
    computedCurrentPageIndex: function() {
      var t = 1;
      return (
        this.$route.query.page &&
          (t = this.adminContent.en.posts_setup[this.$route.query.page]
            ? parseInt(this.$route.query.page, 10)
            : 0),
        t
      );
    },
  },
  beforeCreate: function() {
    this.$route.query.page ||
      this.$router.push("/salameh-catering/catering-setup?page=1");
  },
  created: function() {
    true
      ? this.$route.query.page ||
        this.$router.replace("/salameh-catering/catering-setup?page=1")
      : this.$router.replace("/404"),
      (this.onResize = this.onResize.bind(this)),
      (this.posts = this.computedPosts),
      (this.pages = this.computedPages),
      (this.currentPageIndex = this.computedCurrentPageIndex),
      this.eventHub.$on("close:popin", this.onClosePopin),
      this.eventHub.$on("resize", this.onResize);
  },
  destroyed: function() {
    this.eventHub.$off("close:popin", this.onClosePopin),
      this.eventHub.$off("resize", this.onResize);
  },
  mounted: function() {
    this.eventHub.$emit("page:ready"), this.onResize();
  },

  methods: {
    GetCarBrandCateg() {
      this.CarModel = this.content[this.selectedOption];
    },
    onResize: function() {},
    onOpenPopin: function(t, e) {
      if (this.isButtonClicked) return false;
      // alert("popin main no");
      var n = this;
      (this.popinIndex = 0),
        (this.popinContent = this.posts[e]),
        (this.popinTitle = this.posts[e].title),
        this.eventHub.$emit("disable:scroll"),
        this.eventHub.$emit("open:popin"),
        setTimeout(function() {
          (n.isPopinActive = !0),
            n.$el.classList.add("is-popin-active"),
            n.onTransition();
        }, 50);
    },
    onOpenPopinPHOTOS: function(t, e) {
      this.isButtonClicked = true;

      var n = this;
      (this.popinIndex = 0),
        (this.popinContent = this.posts[e]),
        (this.popinTitle = this.posts[e].title),
        this.eventHub.$emit("disable:scroll"),
        this.eventHub.$emit("open:popin"),
        //this.eventHub.$emit("open:popinphotos"),
        setTimeout(function() {
          n.isButtonClicked = false;
          (n.isPopinActivePhotos = !0),
            //n.$el.classList.add("is-popin-active--photos"),
            n.$el.classList.add("is-popin-active"),
            n.onTransition();
        }, 50);
    },
    onHoverPopin: function(t, e) {
      /*
                             var n = this;
                              n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars--back"),
                              n.$el.querySelector('#'+t).classList.add("is-start-switching--cars")
                              */
    },
    onHoverOutPopin: function(t, e) {
      /*
                         var n = this;
                           n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars"),
                          n.$el.querySelector('#'+t).classList.add("is-start-switching--cars--back")
                          */
    },
    onClosePopin: function() {
      this.eventHub.$emit("enable:scroll"),
        (this.isPopinActive = !1),
        (this.isPopinActivePhotos = !1),
        //this.isBoardActive = !1,
        this.$el.classList.remove("is-popin-active"),
        this.onTransition();
    },
    onTransition: function() {
      var t = this;
      this.$el.classList.add("is-switching"),
        clearTimeout(this._timerTransition),
        (this._timerTransition = setTimeout(function() {
          t.$el.classList.remove("is-switching");
        }, 650));
    },
  },
};
</script>
<style scoped>
/*SVG ICON SYSTEM*/
.icon {
  display: inline-flex;
  align-self: center;
}

.icon svg,
.icon img {
  height: 2rem;
  width: 2rem;
  fill: currentColor;
}

.icon.baseline svg,
.icon img {
  top: 0.125em;
  position: relative;
}

h3 {
  margin: 0 0 5px 0;
  padding: 0;
  line-height: 1;
  font-weight: normal;
  position: relative;
  color: #000;
}
/*H Tag Sizing*/

h3 {
  font-size: 15px;
}
.containercarousel_Image .style-3 ins {
  font-weight: 200;
  text-decoration: none;
  padding: 0px;
  margin: 0px;
  color: #132148;
}
.containercarousel_Image .blockdownInfo {
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
  opacity: 1;
  position: relative;
  top: 0;
  left: 0;
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  text-align: left;
}
.containercarousel_Image {
  position: relative;
  padding: 0px;
}
.icontext {
  position: relative;
  top: -10px;
  left: -8px;
}
.t-btn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.t-btn span:after {
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}

.t-btn:hover span {
  padding-right: 25px;
}

.t-btn:hover span:after {
  opacity: 1;
  right: 0;
}
@media screen and (max-width: 550px) {
  .t-btn span:after {
    content: "";
    position: absolute;
    opacity: 0;
    top: 0;
    right: 0;
    transition: 0.5s;
  }
  .t-btn:hover span {
    padding-right: 0px;
  }
  .t-btn:hover span:after {
    opacity: 0;
    right: 0;
  }
  .icon svg,
  .icon img {
    height: 1.5rem;
    width: 1.5rem;
    fill: currentColor;
  }
  .icontext {
    position: relative;
    top: -5px;
    left: -5px;
  }
}
</style>
